import React from "react";
import {
	Button,
	ClassNameProps,
	If,
	Image,
	ImageProps,
	makeClassName,
	Modal,
	ModalProps,
	Row,
	StyleProps,
} from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import styles from "./styles.module.css";

export type ImageWithModalProps = ImageProps & {
	modalBackButtonText?: string;
	containerClassName?: string;
};

export function ImageWithModal({ modalBackButtonText, containerClassName, ...props }: ImageWithModalProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<div
				onClick={openModal}
				className={makeClassName(styles["image-with-modal__image-container"], containerClassName)}
			>
				<Image {...props} />
			</div>

			<Modal.If condition={isModalOpen}>
				<ImageModal src={props.src} backButtonText={modalBackButtonText} onClose={closeModal} />
			</Modal.If>
		</React.Fragment>
	);
}

export type ImageModalProps = Pick<ImageProps, "src"> & {
	backButtonText?: string;
} & Pick<ModalProps, "ifRef" | "onClose"> &
	Partial<ClassNameProps & StyleProps>;

export function ImageModal({ src, backButtonText, ifRef, onClose, className, style }: ImageModalProps) {
	return (
		<Modal ifRef={ifRef} size="large" onClose={onClose} className={className} style={style}>
			<If condition={!!backButtonText}>
				<Modal.Header>
					{onClose && (
						<Button variant="link" size="small" onClick={onClose}>
							<Row justify="spaced-start" align="center" horizontalSpacing="0.375rem">
								<Icon.ArrowLeft size={14} /> {backButtonText}
							</Row>
						</Button>
					)}
				</Modal.Header>
			</If>
			<Modal.Body className={styles["image-modal__body"]}>
				<Image src={src} sizing="contain" className={styles["image-modal__image"]} />
			</Modal.Body>
		</Modal>
	);
}
